import { MINUTES_PER_HOUR } from "./constants";

export default function hoursToMinutes(hours: number) {
  return Math.floor(hours * MINUTES_PER_HOUR);
}
